<template>
  <section class="team-block">
    <div class="container">
      <div class="row team-block__inner">
        <template v-for="(person, index) in data.team_member">
          <div
              :class="
              `col-12 col-md-4 col-sm-6 team-block__person ${
                activePerson && activePerson.first_name === person.first_name
                  ? 'team-block__person--active'
                  : ''
              }`
            "
              :key="index"
              @click="showPersonProfile(person, index)"
          >
            <div class="team-block__person__image">
              <WordPressImage :image="person.image" size="medium_large"/>
            </div>
            <p class="team-block__person__name">
              {{ person.first_name }}<br/>{{ person.last_name }}
            </p>
          </div>
          <!--The desktop person panel-->
          <TeamMemberProfile
              v-if="
              (index % 3 === 2 || index === data.team_member.length - 1) &&
                visiblePanelIndexes.desktop === Math.floor(index / 3)
            "
              class="d-none d-md-block col-12 team-block__profile-panel team-block__profile-panel--desktop"
              :key="`profile-panel-desktop-${Math.floor(index / 3)}`"
              :ref="`profile-panel-desktop-${Math.floor(index / 3)}`"
              :person="activePerson"
              @closed="closed"
          />
          <!--The mobile person panel-->
          <TeamMemberProfile
              v-if="visiblePanelIndexes.mobile === index"
              class="d-block d-md-none col-12 team-block__profile-panel team-block__profile-panel--mobile"
              :key="`profile-panel-mobile-${index}`"
              :ref="`profile-panel-mobile-${index}`"
              :person="activePerson"
              @closed="closed"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import WordPressImage from "@/components/WordPressImage";
import TeamMemberProfile from "@/components/TeamMemberProfile";

export default {
  name: "TeamComponent",
  components: {TeamMemberProfile, WordPressImage},
  data() {
    return {
      data: window.team_data,
      active_customer_index: null,
      activePerson: null,
      // Store the visible panel indexes here
      visiblePanelIndexes: {
        desktop: null
        // mobile: null,
      }
    };
  },
  methods: {
    closed() {
      this.activePerson = null
    },
    showPersonProfile(personData, personIndex) {
      this.activePerson = personData;
      // Get the indexes of the various panels
      const desktopPanelIndex = Math.floor(personIndex / 3);
      const mobilePanelIndex = personIndex;
      this.visiblePanelIndexes.desktop = desktopPanelIndex;
      this.visiblePanelIndexes.mobile = mobilePanelIndex;
    }
  }
};
</script>

<style lang="scss">
.team-block {
  background-color: #435bdb;

  &__inner {
    padding: 0px;
  }

  &__person {
    padding: 0px;
    position: relative;
    cursor: pointer;

    &--active {
      .team-block__person__name {
        background-color: #435bdb;
      }
    }

    &__image {
      position: relative;
      z-index: 1;
      height: 0;
      padding-top: 127%;
      overflow: hidden;

      @include media-breakpoint-down(sm) {
        z-index: inherit;
      }

      img {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }

    &__name {
      z-index: 2;
      position: absolute;
      bottom: 0;
      left: 0;
      width: 67%;
      min-height: 83px;
      min-width: 249px;
      background-color: #eb0056;
      padding: {
        left: 25px;
        right: 25px;
      }
      display: flex;
      align-items: center;
      margin-bottom: 0;
      color: white;
      font-weight: bold;
      line-height: 22px;

      @include media-breakpoint-down(md) {
        min-width: initial;
      }
    }
  }
}
</style>
